import { Action, createReducer, on } from '@ngrx/store';

import {
  setActiveAlertsUIAction,
  loadAlertSuccessAction,
  resetWidgetDataAction
} from '@shared/widgets/store/actions/alerts.action';

export const initialState = false;

const featureReducer = createReducer(
  initialState,
  on(setActiveAlertsUIAction, (state, { payload }) => payload),
  on(loadAlertSuccessAction, (state, { data }) => !!data && Object.keys(data).length > 0),
  on(resetWidgetDataAction, () => initialState)
);

export const activateAlertsReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};
